import styled from '@emotion/styled/macro';
import { PopoverItem, Variables } from '@enter/core';
import { ChartCard } from './chart-card';

export const PayerMixCard = styled(ChartCard)``;

export const Message = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    flex-grow: 1;
    text-align: center;

    font-size: 18px;
    font-weight: 500;
`;

export const OptionItem = styled(PopoverItem)`
    color: ${Variables.Colors.n100};
    font-weight: 500;
`;
